import { PublicHeaderWrapper } from 'layout/PublicLayout/styles';
import React from 'react';
import { useTranslation } from 'react-i18next';

type PublicHeader = {
  title?:string,
  subtitle?:string
}

export default function PublicHeader({ title, subtitle }: PublicHeader) {
  const { t } = useTranslation();

  return (
    <PublicHeaderWrapper>
      <img width='226px' height='68px' src="/images/login-logo.png" />
      <div className='public-header-title'>{t(title)}</div>
      <div className='public-header-subtitle'>{t(subtitle)}</div>
    </PublicHeaderWrapper>
  );
}
